import { DateFormat, formatDate } from '@prometheus/utils';
import React, { FC, useEffect, useState } from 'react';
import { getInfo } from 'src/api';
import { BuildInfoDTO, BuildInfoData } from 'src/interfaces';
import { InfoContainer } from './BuildInfo.styles';

export const BuildInfo: FC<{ isVisible?: boolean }> = ({
  isVisible = true,
}) => {
  const [buildInfo, setBuildInfo] = useState<BuildInfoData>();
  useEffect(() => {
    getInfo()
      .then((result: BuildInfoDTO) => {
        setBuildInfo(result.build);
      })
      .catch(console.error);
  }, []);
  return isVisible ? (
    <InfoContainer>
      <div>{buildInfo?.version}</div>
      <div>({formatDate(buildInfo?.time, DateFormat.DATE_TIME)})</div>
    </InfoContainer>
  ) : (
    <></>
  );
};
